import { render } from "./ModalMessage.vue?vue&type=template&id=cb3229ec&lang=pug"
import script from "./ModalMessage.vue?vue&type=script&lang=js"
export * from "./ModalMessage.vue?vue&type=script&lang=js"

import "./ModalMessage.vue?vue&type=style&index=0&id=cb3229ec&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__